module.exports = __webpack_public_path__ + "static/media/red-star-right@1x.dbe3ca58.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/red-star-right@1x.png
 ** module id = 2100
 ** module chunks = 44
 **/